import { TrackEvent } from '../../enums/Content/TrackEvent';
import TrackInterface from '../../graphql/Rooms/TrackInterface';
import SimpleTracker from './SimpleTracker';

export default class DocTracker {
  private contentId: string;

  private contactId?: string;

  private roomId?: string;

  private version?: number;

  private page = 0;

  private tracker: SimpleTracker;

  constructor(
    contentId: string,
    contactId?: string,
    roomId?: string,
    version?: number
  ) {
    this.contentId = contentId;
    this.contactId = contactId;
    this.roomId = roomId;
    this.version = version;

    this.tracker = new SimpleTracker();
  }

  /**
   * Storing the document's metadata needed for tracking the document progress
   * and activates the tracker to start the polling and setting up the listeners.
   */
  public attach(currentPage: number) {
    this.page = currentPage;
    this.tracker.attach(this.trackElapsedTime.bind(this));
  }

  /**
   * Proxy to simple tracker `detach` method
   */
  public detach() {
    this.tracker.detach();
  }

  /**
   * Proxy to simple tracker `setActive` method
   */
  public setActive(active: boolean) {
    this.tracker.setActive(active);
  }

  /**
   * Tracks the progress so far before changing to a new document's page.
   * The tracker and its polling is paused so the responsibility for the
   * tracking is delegated to the polling's tick, then it's resumed
   * to restart the interval.
   */
  public trackProgress(newPage: number) {
    // pausing the tracking to fire a track event
    this.tracker.setActive(false);
    // resuming it immediately so it's reset and start from where it left off
    this.tracker.setActive(true);
    this.page = newPage;
  }

  private trackElapsedTime(elapsedTime: number) {
    try {
      if (!(this.roomId && this.version)) {
        return;
      }

      new TrackInterface(this.contactId).track({
        contentId: this.contentId,
        event: TrackEvent.PAGE_TRACKERS,
        measure: elapsedTime,
        roomId: this.roomId,
        version: this.version,
        metadata: {
          page: this.page,
          seen: true,
          seconds: elapsedTime,
        },
      });
    } catch (e) {
      // user shouldn't be alerted about this fail, but we're catching
      // this exception to avoid "Uncaught promise reject" warnings
    }
  }
}
